export default __webpack_public_path__ + "static/media/ci4.18669111.png";